import { Route, Routes } from 'react-router-dom';

import { RequireAuth } from './auth/RequireAuth';
import { AppLayout } from './components/AppLayout';
import { Files } from './pages/Files';
import { Glossary } from './pages/Glossary';
import { Group } from './pages/Group';
import { Login } from './pages/Login';
import { Recent } from './pages/Recent';

export const App = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route
      path="/"
      element={
        <RequireAuth>
          <AppLayout>
            <Files />
          </AppLayout>
        </RequireAuth>
      }
    />
    <Route
      path="/groups/:groupId"
      element={
        <RequireAuth>
          <AppLayout>
            <Group />
          </AppLayout>
        </RequireAuth>
      }
    />
    <Route
      path="/glossary"
      element={
        <RequireAuth>
          <AppLayout>
            <Glossary />
          </AppLayout>
        </RequireAuth>
      }
    />
    <Route
      path="/recent"
      element={
        <RequireAuth>
          <AppLayout>
            <Recent />
          </AppLayout>
        </RequireAuth>
      }
    />
  </Routes>
);
